<template>
	<div style="page">
		<!-- 顶上查询 -->
		<div class="searchBlock">
			<!-- <el-date-picker style="margin-right: 10px;" v-model="time" format="yyyy-MM-dd" type="datetimerange"
				:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
				align="right" />
			<el-date-picker style="margin-right: 10px;" v-model="time" format="yyyy-MM-dd" type="datetimerange"
				:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
				align="right" /> -->
			<!-- <el-button @click="goTagView">会话标签管理</el-button> -->
		</div>

		<!-- 数据展示块 -->
		<div class="dataBlock">
			<div class="itemBlock">
				<div><span>进行中会话数</span></div>
				<div class="numberCenter"><span>{{ing.all}}</span></div>
				<div><span>活跃会话：{{ing.active}} | 历史会话：{{ing.history}}</span></div>
			</div>
			<div class="itemBlock">
				<div><span>结束会话数</span></div>
				<div class="numberCenter"><span>{{end}}</span></div>
				<!-- <div><span>活跃会话：1 | 历史会话：6</span></div> -->
			</div>
			<div class="itemBlock">
				<div><span>总会话数</span></div>
				<div class="numberCenter"><span>{{all.all}}</span></div>
				<div><span>机器人：{{all.bot}} | 未分配：{{all.unassigned}}</span></div>
			</div>
		</div>

		<!-- 第三块查询 -->
		<div class="searchBlock">
			<div class="searchBlock tabBlock">
				<div class="tabIndex" v-for="(item ,index) in tabList"
					:class=" tabIndex == item.type ? 'tabIndexActive' : '' " :key="index" @click="tabChange(item)">
					{{ item.name }}
				</div>
			</div>
			<el-input style="margin-left: 10px;flex:2" placeholder="请输入内容" v-model="nickname" class="input-with-select">
				<el-button slot="prepend" icon="el-icon-search" @click="getList()"></el-button>
				<el-button slot="append" type="info" @click="reset()">重置</el-button>
			</el-input>
		</div>

		<!-- 有关表格操作 -->
		<div class="opeation">
			<!-- <el-button style="color: white;background-color: #2e4fed;" :disabled="!selection?.length">批量操作</el-button> -->
			<div class="rightBottom searchBlock">
				<el-pagination :current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="10"
					layout="total,  sizes" :total="total">
				</el-pagination>
				<div class="page-wrapper">
					<el-button @click="prevPage" :disabled="page <= 1">‹</el-button>

					<div class="page-input">
						<el-input style="width: 70px;margin-right: 10px;" type="number" v-model.number="inputPage"
							@keyup.enter="jumpPage"></el-input>
						<span>/ {{ totalPage }}</span>
					</div>

					<el-button @click="nextPage" :disabled="page >= totalPage">›</el-button>
				</div>
			</div>
		</div>

		<!-- 表格 -->
		<div class="table">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" min-width="55">
				</el-table-column> -->
				<el-table-column fixed align="center" prop="nickname" label="用户名" min-width="250">
					<template slot-scope="scope">
						<span style="color: #2e4fed;cursor: pointer;">{{ scope.row.nickname }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user_id" align="center" label="用户id" min-width="220">
				</el-table-column>
				<el-table-column prop="channel_id" align="center" label="渠道id" min-width="120">
				</el-table-column>
				<el-table-column align="center" prop="customer_service_id" label="最后接待客服" min-width="120">
				</el-table-column>
				<el-table-column align="center" prop="address" label="服务开始时间" min-width="300">
				</el-table-column>
				<el-table-column align="center" prop="zip" label="服务结束时间" min-width="300">
				</el-table-column>
				<el-table-column align="center" prop="status" label="状态" min-width="120">
				</el-table-column>
				<!-- <el-table-column prop="zip" label="城市" min-width="120">
				</el-table-column>
				<el-table-column prop="zip" label="语言" min-width="120">
				</el-table-column>
				<el-table-column prop="zip" label="状态" min-width="120">
				</el-table-column>
				<el-table-column prop="zip" label="备注" min-width="120">
				</el-table-column>
				<el-table-column prop="zip" label="创建时间" min-width="120">
				</el-table-column> -->
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				time: '',

				tabIndex: 'activeChat',
				tabList: [{
						name: '活跃会话',
						type: 'activeChat'
					},
					{
						name: '历史会话',
						type: 'historyChat'
					},
					{
						name: '已结束会话',
						type: 'endChat'
					},
					{
						name: '未分配',
						type: 'unset'
					},
					{
						name: '机器人',
						type: 'robot'
					},
				],

				page: 1,
				inputPage: 1,
				pageSize: 10,
				total: 40,
				totalPage: 4,
				tableData: [],
				selection: [],
				nickname: '',
				all: {},
				ing: {},
				end: '',
			}
		},
		methods: {
			tabChange(item) {
				this.tabIndex = item.type
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			prevPage() {
				if (this.page > 1) this.page--
				this.inputPage = this.page
				this.getList()
			},
			nextPage() {
				if (this.page < this.totalPage) this.page++
				this.inputPage = this.page
				this.getList()
			},
			jumpPage() {
				let p = this.inputPage
				if (p < 1) p = 1
				if (p > this.totalPage) p = this.totalPage
				this.page = p
			},
			reset(){
				this.nickname = ''
				this.getList()
			},
			async getList() {
				const res = await this.$axios.get(this.$apis.getConnectionList, {
					page: this.page,
					limit: this.pageSize,
					nickname: this.nickname,
				})
				if (res.code == 1) {
					this.tableData = res.data.list
					this.ing = res.data.ing
					this.all = res.data.all
					this.end = res.data.end
					this.total = res.data.total
					this.totalPage = Math.ceil(this.total / this.pageSize)
				}
			},
			goTagView(){
				this.$nav.go('/home/customer/tagSetting');
			}
		},
		mounted() {
			this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		height: 95%;

		.searchBlock {
			display: flex;
			align-content: center;
			align-items: center;
		}

		.dataBlock {
			display: flex;
			align-content: center;

			.itemBlock {
				flex: 1;
				text-align: center;
				padding: 20px;
				border: 1px solid #cbcbcb;
				margin: 10px;
				border-radius: 10px;
				color: #999;
				font-size: 13px;

				.numberCenter {
					color: #2e4fed;
					font-size: 25px;
					margin: 10px;
				}
			}
		}

		.tabBlock {
			flex: 1;
			/* margin-right: 10px; */
			/* width: 40%; */

			.tabIndex {
				background-color: #f8f9f9;
				color: #949aa6;
				cursor: pointer;
				padding: 10px 25px;
				font-size: 14px;
				flex-wrap: nowrap;
				white-space: nowrap;
			}

			.tabIndex:hover {
				/* background-color: #f8f9f9; */
				color: #2e4fed;
			}

			.tabIndexActive {
				background-color: #cfd7f6;
				color: #2e4fed;
			}
		}

		.opeation {
			margin: 10px 0;
			display: flex;
			align-content: center;
			justify-content: space-between;
			
			.page-wrapper {
				display: flex;
				align-items: center;
				/* height: 80%; */

				.page-input {
					margin: 0px 10px;
					display: flex;
					align-items: center;
				}
			}
		}
		
		.table{
			padding: 10px;
			overflow: auto;
			height: 444px;
		}

		/* .flBlock{
			display: flex;
			align-content: center;
		} */
	}
</style>